import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

import { Spinner } from "@/components/ui/spinner";
import { config } from "@/config";

const RouteComponent = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({
      clientId: config.AUTH0_CLIENT_ID,
      logoutParams: {
        returnTo: config.BASE_URL,
      },
    });
  }, [logout]);

  return (
    <div className="h-svh w-full">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <h1 className="text-[7rem] leading-tight font-bold">
          <Spinner />
        </h1>
        <p className="font-medium">Signing out of your session...</p>
      </div>
    </div>
  );
};

export const Route = createFileRoute({
  component: RouteComponent,
});
